module.exports = __webpack_public_path__ + "static/media/threads .2a339fd6.svg";